import script from "./AnnahmeKriterien.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnahmeKriterien.vue?vue&type=script&setup=true&lang=js"

import "./AnnahmeKriterien.vue?vue&type=style&index=0&id=2ccbda66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ccbda66"]])

export default __exports__